import React, { useEffect } from "react";
import { Result, Button } from "antd";
import { Link } from "react-router-dom";
import warningImage from "../../images/alert-sign.png";
import { t } from "i18next";

const NoSchedules = () => {
  useEffect(() => {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (isMobile) {
      const element = document.querySelector("#scrollToNoSchedule");
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <>
      <div className="no-schedules-container">
        <Result
          icon={
            <img
              className="no-schedules-image"
              src={warningImage}
              alt="noSchedule"
            />
          }
          title={t("resultsNotFound")}
          subTitle={
            <p style={{ fontSize: "18px" }}>{t("notFoundForThisDate")}</p>
          }
          extra={[
            <Link to="/" key="home-link">
              <Button
                style={{ width: "150px" }}
                type="primary"
                className="custom-button"
                size="large"
              >
                {t("home")}
              </Button>
            </Link>,
          ]}
        />
      </div>
      <div className="no-schedule-scroll-to-item" id="scrollToNoSchedule"></div>
    </>
  );
};

export default NoSchedules;
